import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { IconColor } from '@freelancer/ui/icon';
import {
  LinkColor,
  LinkHoverColor,
  LinkUnderline,
  LinkWeight,
} from '@freelancer/ui/link';
import { ProgressColor } from '@freelancer/ui/progress-bar';

@Component({
  selector: 'app-new-account-progress-bar',
  template: `
    <div
      class="ProgressBarContainer mb-large"
      flTrackingSection="NewAccountProgressBar"
    >
      @if (showBackButton) {
        <fl-link
          class="ProgressBarContainer-backButton"
          i18n="New account back button"
          flTrackingLabel="NewAccountBackButton"
          [iconName]="'ui-arrow-left-alt'"
          [iconAnimation]="true"
          [color]="LinkColor.INHERIT"
          [weight]="LinkWeight.MEDIUM"
          [underline]="LinkUnderline.NEVER"
          [iconColor]="IconColor.INHERIT"
          [hoverColor]="LinkHoverColor.INHERIT"
          (click)="backButtonClicked.emit()"
        >
          Back
        </fl-link>
      }
      @if (showProgressBar) {
        <div class="ProgressBarContainer-progressBar">
          <fl-progress-bar
            class="mr-xxsmall"
            label="New account progress bar label"
            i18n-label="New account progress bar label"
            [color]="ProgressColor.PINK"
            [progressPercentage]="progressPercentage"
          ></fl-progress-bar>
          <p class="ProgressBarContainer-progressBar-text">
            {{ currentStep }}/{{ totalSteps }}
          </p>
        </div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./new-account-progress-bar.component.scss'],
  standalone: true,
  imports: [CommonModule, UiModule, ComponentsModule, TrackingModule],
})
export class NewAccountProgressBarComponent {
  LinkHoverColor = LinkHoverColor;
  LinkColor = LinkColor;
  LinkWeight = LinkWeight;
  LinkUnderline = LinkUnderline;
  IconColor = IconColor;
  ProgressColor = ProgressColor;

  @Input() currentStep = 1;
  @Input() progressPercentage = 0;
  @Input() totalSteps = 3;
  @Input() showBackButton = true;
  @Input() showProgressBar = true;

  @Output() backButtonClicked = new EventEmitter<void>();
}
